import React from 'react';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-[#0a1628] flex items-center justify-center px-4" data-testid="maintenance-page">
      <div className="text-center max-w-lg">
        {/* Logo */}
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl text-[#c9a227] mb-6 tracking-wide">
          EQUUS PRIME
        </h1>
        
        {/* Divider */}
        <div className="w-20 h-0.5 bg-[#c9a227] mx-auto mb-8"></div>
        
        {/* Message */}
        <h2 className="font-display text-xl sm:text-2xl text-white mb-4">
          Sito in manutenzione
        </h2>
        <p className="text-white/60 text-sm sm:text-base leading-relaxed mb-8">
          Stiamo lavorando per migliorare la vostra esperienza. Il sito sarà disponibile a breve.
        </p>
        
        {/* Animated dots */}
        <div className="flex justify-center gap-2 mb-10">
          <div className="w-2.5 h-2.5 bg-[#c9a227] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2.5 h-2.5 bg-[#c9a227] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2.5 h-2.5 bg-[#c9a227] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

        {/* Contact */}
        <p className="text-white/40 text-xs">
          Per informazioni: <a href="mailto:info@equusprime.it" className="text-[#c9a227] hover:underline">info@equusprime.it</a>
        </p>
        
        {/* Hidden admin access */}
        <a href="/login" className="text-white/20 text-xs mt-8 block hover:text-[#c9a227] transition-colors" data-testid="maintenance-admin-link">
          Accesso Admin
        </a>
      </div>
    </div>
  );
};

export default MaintenancePage;
